import { api } from '@marketplace-web/core-api/core-api-client-util'

import { DeleteFeedbackCommentArgs, FeedbackCommentResp } from '../types/feedback-comment'

export const deleteFeedbackComment = ({ feedbackId }: DeleteFeedbackCommentArgs) =>
  api.put<FeedbackCommentResp>(`/user_feedbacks/${feedbackId}/comment`, { comment: null })
